var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.receipt, rules: _vm.rules }
        },
        [
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("服务商")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "sellerName" } },
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x bottom-line",
                        attrs: { disabled: "", type: "text" },
                        model: {
                          value: _vm.receipt.sellerName,
                          callback: function($$v) {
                            _vm.$set(_vm.receipt, "sellerName", $$v)
                          },
                          expression: "receipt.sellerName"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                        attrs: { title: "选择" },
                        on: {
                          click: function($event) {
                            _vm.selectServicer()
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("是否常规服务")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "comnSvcFlag" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: {
                            change: function($event) {
                              _vm.setComnSvcFlag()
                            }
                          },
                          model: {
                            value: _vm.comnSvcFlag,
                            callback: function($$v) {
                              _vm.comnSvcFlag = $$v
                            },
                            expression: "comnSvcFlag"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              staticClass: "radio mr10",
                              attrs: { label: true }
                            },
                            [_vm._v("是")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            { staticClass: "radio", attrs: { label: false } },
                            [_vm._v("否")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("工单信息")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "swb-btn swb-btn-small",
            on: {
              click: function($event) {
                _vm.selectWorkVoucher()
              }
            }
          },
          [_vm._v("选择工单")]
        ),
        _vm._v(" "),
        !_vm.receiptAllowed
          ? _c(
              "span",
              {
                staticClass: "input-tip error",
                staticStyle: { "font-size": "12px" }
              },
              [_vm._v("提示:常规服务工单无法合并验收，会单独生成验收单")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-layout" }, [
        _vm.workVoucherList != null && _vm.workVoucherList.length > 0
          ? _c(
              "div",
              [
                _c("div", { staticClass: "simple-row" }, [
                  _c("div", { staticClass: "right" }, [
                    _vm.workVoucherList != null
                      ? _c("span", [
                          _vm._v(
                            "已选择(" + _vm._s(_vm.workVoucherList.length) + ")"
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.workVoucherList,
                      border: "",
                      "tooltip-effect": "dark",
                      maxHeight: "400"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "no",
                        label: "工单号",
                        width: "200",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "servcType",
                        label: "工单类型",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.servcTypeMap[rows.row.servcType])
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "contractNo",
                        label: "系统合同编号",
                        width: "140",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "devcGroupFullName",
                        label: "维保分组",
                        width: "140",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "buyerShopFullName",
                        label: "部门全称",
                        width: "150",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "creatorName",
                        label: "创建人",
                        width: "100",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "servicerName",
                        label: "服务商",
                        width: "240"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "toDoorFee",
                        align: "right",
                        width: "100",
                        label: "上门费(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s((rows.row.toDoorFee || 0).toFixed(2))
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "generallFee",
                        align: "right",
                        width: "100",
                        label: "服务费(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s((rows.row.generallFee || 0).toFixed(2))
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "accFee",
                        align: "right",
                        width: "100",
                        label: "配件费(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.accFee != null
                                ? _c("span", [
                                    _vm._v(_vm._s(rows.row.accFee.toFixed(2)))
                                  ])
                                : _c("span", [_vm._v("0.00")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "examineTime",
                        label: "确认完成时间",
                        width: "140"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "100",
                        label: "操作",
                        fixed: "right"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.removeVoucher(rows.$index)
                                    }
                                  }
                                },
                                [_vm._v("移除")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1efa7fc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1efa7fc6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/receipt/ServcWorkReceiptSave.vue
// module id = 3013
// module chunks = 0